import { nextTick } from 'vue'

import { loading$ } from '@shared/services'
import { getNextRoute } from '@dvp/helpers/Route'

import productStructureStore from '@shared/store/productStructure'
import basketStore from '@shared/store/basket'
import useStatus from '@shared/hooks/useStatus'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

// HOOKS
const { offerValid } = useStatus()

function reroute(to, from, next) {
  if (from.name) {
    next({
      name: from.name,
      params: from.params,
    })
  } else {
    next({
      name: getNextRoute(basketStore.basket),
      params: {
        lang: to.params.lang
      },
      replace: true,
    })
  }
}

export default [
  {
    beforeEnter: (to, from, next) => {
      // Trying to access url without a basket at all
      if (basketStore.isTemporaryBasket()) return reroute(to, from, next)

      productStructureStore.ready().then(() => {
        if (!offerValid(basketStore.basket, basketStore.basket.persons)) {
          loading$.end()
          return reroute(to, from, next)
        } else {
          try {
            // @note: loading could already be active from healthquestions
            if (!loading$.getState().active) loading$.start()

            // @note: If we don't use nextTick here,
            // then the UI will just skip the loading$.start()
            // and between hq and the submit-step, it will look like a hangup
            nextTick(() => {
              // FLEX-1790 always send submitScreen param before entering submit screen
              basketStore.updateOvpBasket({}, {}, { submitScreen: true }).then(() => {
                loading$.end()
                next()
              })
            })
          } catch {
            loading$.failed()
          }
        }
      })
    },
    component: () => import('@shared/modules/Dvp/screens/ScreenSubmit'),
    meta: {
      index: ROUTE_INDEX.SUBMIT,
      basket: {
        readonly: true,
      },
    },
    name: ROUTE_NAME.SUBMIT,
    path: 'submit',
  },
]
